import { render, staticRenderFns } from "./Scorecard.vue?vue&type=template&id=d706bf96"
import script from "./Scorecard.vue?vue&type=script&lang=js"
export * from "./Scorecard.vue?vue&type=script&lang=js"
import style0 from "./Scorecard.vue?vue&type=style&index=0&id=d706bf96&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports